module.exports = __webpack_public_path__ + "static/media/pinata.9d0c78cf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pinata.svg
// module id = 36
// module chunks = 0